// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GesH","col":"styles_col__2g-PJ"};